<template>
  <div class="home">
    <Header @update="handleUpdate"></Header>
    <home-banner :key="homeBanner"></home-banner>
    <HomeCard :key="homeCard"></HomeCard>
    <home-login></home-login>
    <HomeCircle></HomeCircle>
    <four-card></four-card>
    <OurServices :key="menuKey"></OurServices>
    <center-image></center-image>
    <HomeTitle :content="list[1]"></HomeTitle>
    <home-case :key="homeCase"></home-case>
    <CooperativePartner></CooperativePartner>
    <leave-message></leave-message>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

import HomeBanner from "../components/home/HomeBanner";
import HomeCard from "../components/home/HomeCard";
import HomeCircle from "../components/home/HomeCircle";
import FourCard from "../components/home/FourCard";
import HomeLogin from "../components/home/HomeLogin";
import HomeTitle from "../components/home/HomeTitle";
import OurServices from "../components/home/OurServices";
import CenterImage from "../components/home/CenterImage";
import HomeCase from "../components/home/HomeCase";
import LeaveMessage from "../components/home/LeaveMessage";
import CooperativePartner from "../components/home/CooperativePartner";
export default {
  name: "home",
  data() {
    return {
      list: [
        { Chinese: "我们的服务", English: "Our Services" },
        { Chinese: "服务案例", English: "Service Case" },
        { Chinese: "信息中心", English: "Information Center" }
      ],
      reFresh: true,
      menuKey: 1,
      homeCard: 2,
      homeBanner: 3,
      homeCase: 4
    };
  },
  components: {
    Header,
    Footer,
    HomeBanner,
    HomeCard,
    HomeCircle,
    FourCard,
    HomeTitle,
    OurServices,
    CenterImage,
    HomeCase,
    LeaveMessage,
    CooperativePartner,
    HomeLogin
  },
  methods: {
    handleUpdate() {
      this.menuKey++;
      this.homeCard++;
      this.homeBanner++;
      this.homeCase++;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/global";
.home {
  width: 100%;
  margin: 0 auto;
  position: relative;
  #home-nav {
    width: 100%;
    background: #fafafa;
  }
}
</style>
